document.addEventListener('DOMContentLoaded', function() {
  fetch('https://sheetdb.io/api/v1/j61z3yvcyw9eu?sheet=Orbimax (PARTNER SITE)')
    .then(function(response) {
      return response.json();
    })
    .then(function(data) {
      
      document.querySelector('.easy-rate').textContent = data[0]['From - Comparison Rate'];
      document.querySelector('.easy-terms').innerHTML = data[0]['Terms Popup'].replace('RATE%', data[0]['From - Comparison Rate']);
      populateEasyWrapper();
    });

    
    function populateEasyWrapper() {
      var easyRate = document.querySelector('.easy-rate').textContent;
      var compRate = easyRate.replace('%', '');
      var easyTerms = document.querySelector('.easy-terms').textContent;
      var LoanTerm = 5;
      var assetPrice = document.querySelector('span[data-product-price]').textContent;
      var uAssetPrice = assetPrice.replace(/[^0-9\.]+/g, '');
      // Get the current URL of the page
      const currentUrl = window.location.href;
     
      if (uAssetPrice > 5000) {
        var assetPriceDeposit = uAssetPrice - (uAssetPrice * 0.20);
        var totalPercent = (compRate * LoanTerm) / 100;
        var totalRepay = Math.floor((assetPriceDeposit * 1 + assetPriceDeposit * totalPercent) / (52.1429 * LoanTerm));

        var easyWrapper = document.createElement('div');
        easyWrapper.classList.add('easy-wrapper');
        easyWrapper.style.marginTop = '10px';
        var easyImg = document.createElement('div');
        easyImg.classList.add('easy-img');
        var img = document.createElement('img');
        img.setAttribute('src', 'https://fast-quote.jade.finance/wp-content/uploads/Jade-Equipment-Finance.svg');
        img.style.width = '76px';
        var a = document.createElement('a');
        a.setAttribute('href', `https://fast-quote.jade.finance/partners/orbimax?ref=${currentUrl}`);
        a.setAttribute('target', '_blank');
        a.setAttribute('rel', 'nofollow');
        //a.setAttribute('data-ref', currentUrl);
        a.appendChild(img);
        easyImg.appendChild(a);
        var easyPriceWrap = document.createElement('div');
        easyPriceWrap.classList.add('easy-price-wrap');
        var small = document.createElement('small');
        small.textContent = 'Finance From ';
        var easyLink = document.createElement('div');
        easyLink.classList.add('easy-link');
        var ecfInfoIcon = document.createElement('img');
        ecfInfoIcon.setAttribute('src', 'https://fast-quote.jade.finance/wp-content/uploads/ecf-info-icon-inverse.webp');
        ecfInfoIcon.setAttribute('title', 'Terms and Conditions apply. Click here to learn more.');
        var weeklyAmount = document.createElement('span');
        weeklyAmount.classList.add('ecf-weekly-amount');
        weeklyAmount.textContent = totalRepay;
        var frequency = document.createElement('span');
        frequency.classList.add('easy-frequency');
        frequency.textContent = 'per week';
        var link = document.createElement('a');
        link.setAttribute('href', `https://fast-quote.jade.finance/partners/orbimax?ref=${currentUrl}`);
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'nofollow');
        link.appendChild(document.createTextNode('$'));
        link.appendChild(weeklyAmount);
        link.appendChild(document.createTextNode(' '));
        link.appendChild(frequency);
        easyLink.appendChild(ecfInfoIcon);
        easyPriceWrap.appendChild(small);
        easyPriceWrap.appendChild(easyLink);
        easyPriceWrap.appendChild(link);
        easyWrapper.appendChild(easyImg);
        easyWrapper.appendChild(easyPriceWrap);

        var productPriceWrap = document.querySelector('.product__price__main');
        productPriceWrap.insertAdjacentElement('afterend', easyWrapper);
        
        var easyLink = document.querySelector('.easy-link');
        easyLink.addEventListener('click', function() {
          var easyTerms = document.querySelector('.easy-terms').textContent;
          var uEasyTerms = easyTerms.replace('RATE%', easyRate);
          alert(uEasyTerms);
        });
      }
    }
});